import React  from 'react'
import AppBar from "@material-ui/core/AppBar";

/* export default function CustomAppBar(props:any) {
  return (
    <AppBar {...props}>
        {props.children}
      </AppBar>
  )
} */

const CustomAppBar = React.forwardRef((props:any,ref:any) => {
  return (
    <AppBar ref={ref} {...props}>
        {props.children}
      </AppBar>
  )
});

export default CustomAppBar;

